import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import { loadStripe } from "@stripe/stripe-js";
import language from '../../../js/stores/language.js';
import carLoan from '../../../js/stores/car-loan.js';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var clientSecret = props.clientSecret;
  var data = props.data;
  var stripe;
  var error = {};
  var paymentIntentLabel = {};
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$stripe$retriev, error, paymentIntent, formData, result;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return loadStripe(process.env.STRIPE_KEY);
        case 1:
          stripe = _context.sent;
          _context.next = 2;
          return stripe.retrievePaymentIntent(clientSecret);
        case 2:
          _yield$stripe$retriev = _context.sent;
          error = _yield$stripe$retriev.error;
          paymentIntent = _yield$stripe$retriev.paymentIntent;
          if (error) {
            console.log("Error: ", error.message);
          }
          paymentIntentLabel = paymentIntent;
          $f7.toast.show({
            text: locale.translate('loan.payment.messageStripePaymentStatus', [paymentIntent.status]),
            closeTimeout: 10000
          });
          if (!(paymentIntent.status === 'succeeded')) {
            _context.next = 5;
            break;
          }
          formData = new FormData();
          formData.append("CarLoanId", data.CarLoanId);
          formData.append("CarId", data.CarId);
          formData.append("LenderId", data.LenderId);
          formData.append("BorrowerId", data.BorrowerId);
          _context.next = 3;
          return carLoan.dispatch('borrowerPays', formData);
        case 3:
          result = _context.sent;
          if (!(result.status !== undefined && result.status !== 200)) {
            _context.next = 4;
            break;
          }
          $f7.toast.show({
            text: result.data.messages.error
          });
          return _context.abrupt("return");
        case 4:
          $f7.toast.show({
            text: locale.translate('loan.payment.messageAfterSucceded')
          });
        case 5:
          $update();
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
        </div>
        <div class="title">${locale.translate('home.title')}</div>
      </div>
    </div>
    <div class="page-content">
      <div class="grid grid-cols-3 text-align-center">
        <div></div>
        <div>
          <a href="/" class="link">
            <i class="material-icons">home</i> ${locale.translate('home.title')}
          </a>
        </div>
        <div></div>
      </div>
      <p>
        ${locale.translate('loan.payment.messageStripePaymentStatus', [paymentIntentLabel.status])}<br />
        ${locale.translate('loan.payment.messageAfterSucceded')}
      </p>
    </div>
  </div>
`
    }
    ;
}
framework7Component.id = '456cc6e794';
export default framework7Component;